import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate for redirection
import Sidebar from "./Siderbar";
import Topbar from "./Topbar";
import Footer from "./Footer";

const Dashboard = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate(); // Hook for redirection

  const [formData, setFormData] = useState({
    main: "",
    pname: "",
    image: null,
    min_qty: "",
    price: "",
    size: "",
    type: "",
    side: "",
    corner: "",
    lamination: "",
    cover: "",
    page_layout: "",
    sticker_size: "",
    inner_paper: "",
    pages: "",
    
    redirect: false, // Default value for the new "Redirect" checkbox
  });

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Handle checkboxes differently
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataObj = new FormData();
    formDataObj.append("main", formData.main);
    formDataObj.append("pname", formData.pname);
    formDataObj.append("min_qty", formData.min_qty);
    formDataObj.append("price", formData.price);
    formDataObj.append("image", formData.image);
    // Include "Use as template" checkbox value
    formDataObj.append("redirect", formData.redirect); // Include "Redirect" checkbox value
  
    // Add other fields dynamically
    Object.keys(formData).forEach((key) => {
      if (
        !["main", "pname", "min_qty", "price", "image",  "redirect"].includes(key) &&
        formData[key] !== ""
      ) {
        formDataObj.append(key, formData[key]); // Add other fields
      }
    });
  
    try {
      const response = await axios.post(`${baseURL}/api/admin-products`, formDataObj, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Product added successfully!");
      console.log(response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  

  return (
    <>
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: "100vh" }}>
          <Topbar />
          <div className="flex-grow-1 p-4">
            <form onSubmit={handleSubmit} className="container mt-4">
              <h2 className="mb-4">Add Product</h2>

              <div className="mb-3">
                <label className="form-label">Category</label>
                <select
                  name="main"
                  value={formData.main}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="" disabled>
                    -- Select Category --
                  </option>
                  <option value="1">Stationery</option>
                  <option value="2">Gifts</option>
                  <option value="3">Marketing Collaterals</option>
                  <option value="4">Packaging</option>
                  <option value="5">Personalise Products</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Product Name</label>
                <input
                  type="text"
                  name="pname"
                  value={formData.pname}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  name="image"
                  className="form-control"
                  onChange={handleFileChange}
                  required
                />
              </div>

             
              <div className="mb-3" style={{ marginLeft: "20px" }}>
                <input
                  type="checkbox"
                  name="redirect"
                  checked={formData.redirect}
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">Redirect to Design Page</label>
              </div>

              <div className="mb-3">
                <label className="form-label">Min Quantity</label>
                <input
                  type="text"
                  name="min_qty"
                  value={formData.min_qty}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="text"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Textarea fields for JSON-like data */}
              {[
                "size",
                "type",
                "side",
                "corner",
                "lamination",
                "cover",
                "page_layout",
                "sticker_size",
                "inner_paper",
                "pages",
              ].map((field) => (
                <div key={field} className="mb-3">
                  <label className="form-label">{field.replace("_", " ").toUpperCase()}</label>
                  <textarea
                    name={field}
                    className="form-control"
                    value={formData[field]}
                    onChange={handleChange}
                    placeholder="Enter comma-separated values (e.g., value1, value2)"
                  />
                </div>
              ))}

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
